/**
 * @module mapbs.components.contextualdatalink.contextualdatalink
 */

import angular from 'angular';

const moduleContextdata = angular.module('mapbsContextualdataLinkModule', []);

moduleContextdata.run(
    /* ngInject */ ($templateCache) => {
        $templateCache.put(
            'mapbs/contextualdatalink',
            require('./contextualdatalink.html')
        );
    }
);

/**
 * @type {!angular.Component}
 */
const contextualdataLinkComponent = {
    controller: 'mapbsContextualdataLinkController as cdLnkCtrl',
    templateUrl: 'mapbs/contextualdatalink',
    bindings: {
        'url': '@mapbsContextualdataLinkUrl',
        'target': '@mapbsContextualdataLinkTarget',
        'label': '@mapbsContextualdataLinkLabel',
        'functionality': '@mapbsContextualdataLinkFunctionality',
    },
};

moduleContextdata.component('mapbsContextualdataLink', contextualdataLinkComponent);

class ContextualdataLinkController {
    /**
   * @private
   * @param {angular.Scope} $scope
   * @param {angular.auto.IInjectorService} $injector Main injector.
   * @constructor
   * @private
   * @ngInject
   */
    constructor($scope, $injector, $q) {
    /**
     * @type {angular.Scope}
     * @private
     */
        this.scope = $scope;

        this.q = $q;

        /**
     * @param {angular.auto.IInjectorService}
     * @private
     */
        this.$injector = $injector;

        /**
     * @type {gmfx.User}
     * @private
     */
        this.user;

        /**
     * @type {string}
     * @export
     */
        this.url;

        /**
     * @type {string}
     * @export
     */
        this.target = '_blank';

        /**
     * @type {string}
     * @private
     */
        this.label;

        /**
     * @type {string|null}
     * @private
     */
        this.functionality;

        this.baseUrl_ = `${$injector.get('baseUrl')}`;

        this.hasInfra3DPermission = false;
        this.getUser();

    }

    /**
   * @private
   */
    hasPermission() {
        const functionality = this.functionality;
        if (
            this.user['functionalities']['authorized_plugins'].indexOf(
                functionality
            ) !== -1
        ) {
            return true;
        } else {
            return false;
        }
    }

    getUser() {
        const url = `${this.baseUrl_}loginuser`;
        const options = {method: 'GET'};
        this.q.all(
            fetch(url, options)
            .then((resp) => resp.json())
            .then((data) => {
                this.user = data;
                this.hasInfra3DPermission = this.hasPermission();
                this.scope.$apply();
            })
        );
    }
}

moduleContextdata.controller(
    'mapbsContextualdataLinkController',
    ContextualdataLinkController
);

export default moduleContextdata;
